import PasswordResetTemplate from "../../templates/PasswordResetTemplate/PasswordResetTemplate";

const PasswordReset = () => {
  return <PasswordResetTemplate />;
};
export default PasswordReset;
